import React from 'react';
import styles from './ErrorBoundary.module.scss';

/**
 * Top-level Error Boundary to catch unhandled React rendering errors.
 * Prevents the entire app from crashing with a white screen.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div className={styles.wrapper}>
          <h1 className={styles.heading}>⚠️ Something went wrong</h1>
          <p className={styles.message}>
            An unexpected error occurred. Please try refreshing the page.
          </p>
          <div className={styles.actions}>
            <button
              className="btn btn-primary"
              onClick={() => window.location.reload()}
            >
              Refresh Page
            </button>
            <button
              className="btn btn-outline-secondary"
              onClick={this.handleReset}
            >
              Try Again
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
